import { render, staticRenderFns } from "./GradeEdit.vue?vue&type=template&id=5cffbc69"
import script from "./GradeEdit.vue?vue&type=script&lang=js"
export * from "./GradeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports